// extracted by mini-css-extract-plugin
export default {"wrapper":"bSJwQG","mobile":"N5TPyw","text":"IJHeHM","icon":"pn_tuh"};